var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"body",style:({'min-height':_vm.myHeight}),attrs:{"id":"anchor_0"}},[_c('my-head',{on:{"changePage":_vm.changePage}}),_c('router-view',{key:_vm.key})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }